import React from 'react';

import { ReactComponent as EmergencyCarbonMonoxideSvg } from 'components/svg/EmergencyCarbonMonoxide.svg';
import { ReactComponent as EmergencyElectricitySvg } from 'components/svg/EmergencyElectricity.svg';
import { ReactComponent as EmergencyElectricityLargeSvg } from 'components/svg/EmergencyElectricityLarge.svg';
import { ReactComponent as EmergencyHvacSvg } from 'components/svg/EmergencyHvac.svg';
import { ReactComponent as EmergencyHvacLargeSvg } from 'components/svg/EmergencyHvacLarge.svg';
import { ReactComponent as EmergencyLeakSvg } from 'components/svg/EmergencyLeak.svg';
import { ReactComponent as RoomAirQualitySvg } from 'components/svg/RoomAirQuality.svg';
import { ReactComponent as RoomDehumidifierSvg } from 'components/svg/RoomDehumidifier.svg';
import { ReactComponent as RoomElectricityFanSvg } from 'components/svg/RoomElectricityFan.svg';
import { ReactComponent as RoomElectricityLightBulbSvg } from 'components/svg/RoomElectricityLightBulb.svg';
import { ReactComponent as RoomElectricityLightChandelierSvg } from 'components/svg/RoomElectricityLightChandelier.svg';
import { ReactComponent as RoomElectricityLightOutdoorSvg } from 'components/svg/RoomElectricityLightOutdoor.svg';
import { ReactComponent as RoomElectricityLightPendantSvg } from 'components/svg/RoomElectricityLightPendant.svg';
import { ReactComponent as RoomElectricityOutletSvg } from 'components/svg/RoomElectricityOutlet.svg';
import { ReactComponent as RoomElectricityOutletLargeSvg } from 'components/svg/RoomElectricityOutletLarge.svg';
import { ReactComponent as RoomElectricityPanelSvg } from 'components/svg/RoomElectricityPanel.svg';
import { ReactComponent as RoomElectricitySolarSvg } from 'components/svg/RoomElectricitySolar.svg';
import { ReactComponent as RoomElectricitySwitchSvg } from 'components/svg/RoomElectricitySwitch.svg';
import { ReactComponent as RoomElectricitySwitchLargeSvg } from 'components/svg/RoomElectricitySwitchLarge.svg';
import { ReactComponent as RoomFloodingSvg } from 'components/svg/RoomFlooding.svg';
import { ReactComponent as RoomFloodingLargeSvg } from 'components/svg/RoomFloodingLarge.svg';
import { ReactComponent as RoomFrozenPipeSvg } from 'components/svg/RoomFrozenPipe.svg';
import { ReactComponent as RoomFurnaceSvg } from 'components/svg/RoomFurnace.svg';
import { ReactComponent as RoomFurnaceLargeSvg } from 'components/svg/RoomFurnaceLarge.svg';
import { ReactComponent as RoomGasLeakSvg } from 'components/svg/RoomGasLeak.svg';
import { ReactComponent as RoomGeneratorSvg } from 'components/svg/RoomGenerator.svg';
import { ReactComponent as RoomGrinderSvg } from 'components/svg/RoomGrinder.svg';
import { ReactComponent as RoomHotWaterHeaterSvg } from 'components/svg/RoomHotWaterHeater.svg';
import { ReactComponent as RoomHumidifierSvg } from 'components/svg/RoomHumidifier.svg';
import { ReactComponent as RoomHvacAirHandlerSvg } from 'components/svg/RoomHvacAirHandler.svg';
import { ReactComponent as RoomHvacOutdoorUnitSvg } from 'components/svg/RoomHvacOutdoorUnit.svg';
import { ReactComponent as RoomLowOrNoWaterSvg } from 'components/svg/RoomLowOrNoWater.svg';
import { ReactComponent as RoomNoHotWaterSvg } from 'components/svg/RoomNoHotWater.svg';
import { ReactComponent as RoomNoiseSvg } from 'components/svg/RoomNoise.svg';
import { ReactComponent as RoomPlumbingLeakSvg } from 'components/svg/RoomPlumbingLeak.svg';
import { ReactComponent as RoomShowerSvg } from 'components/svg/RoomShower.svg';
import { ReactComponent as RoomSinkBathroomSvg } from 'components/svg/RoomSinkBathroom.svg';
import { ReactComponent as RoomSinkKitchenSvg } from 'components/svg/RoomSinkKitchen.svg';
import { ReactComponent as RoomSinkKitchenDisposalSvg } from 'components/svg/RoomSinkKitchenDisposal.svg';
import { ReactComponent as RoomSinkKitchenLargeSvg } from 'components/svg/RoomSinkKitchenLarge.svg';
import { ReactComponent as RoomSinkUtilitySvg } from 'components/svg/RoomSinkUtility.svg';
import { ReactComponent as RoomSmellSvg } from 'components/svg/RoomSmell.svg';
import { ReactComponent as RoomSpigotSvg } from 'components/svg/RoomSpigot.svg';
import { ReactComponent as RoomSumpPumpSvg } from 'components/svg/RoomSumpPump.svg';
import { ReactComponent as RoomThermostatSvg } from 'components/svg/RoomThermostat.svg';
import { ReactComponent as RoomThermostatLargeSvg } from 'components/svg/RoomThermostatLarge.svg';
import { ReactComponent as RoomToiletSvg } from 'components/svg/RoomToilet.svg';
import { ReactComponent as RoomUvLightSvg } from 'components/svg/RoomUvLight.svg';
import { ReactComponent as RoomVentSvg } from 'components/svg/RoomVent.svg';
import { ReactComponent as RoomVentLargeSvg } from 'components/svg/RoomVentLarge.svg';
import { ReactComponent as RoomWaterTreatmentSvg } from 'components/svg/RoomWaterTreatment.svg';
import { ReactComponent as RoomWellPumpSvg } from 'components/svg/RoomWellPump.svg';
import { ReactComponent as TradeElectricalLargeSvg } from 'components/svg/TradeElectricalLarge.svg';
import { ReactComponent as TradeHvacLargeSvg } from 'components/svg/TradeHvacLarge.svg';
import { ReactComponent as TradeOtherLargeSvg } from 'components/svg/TradeOtherLarge.svg';
import { ReactComponent as TradePlumbingLargeSvg } from 'components/svg/TradePlumbingLarge.svg';
import { IIssueIconProps, RoomIconKey } from 'typings';

export const IssueIcon = ({ iconKey, ...props }: IIssueIconProps) => {
  let ResultSvg: React.StatelessComponent<React.SVGProps<SVGSVGElement>>;

  switch (iconKey) {
    case RoomIconKey.AIR_QUALITY:
      ResultSvg = RoomAirQualitySvg;

      break;
    case RoomIconKey.DEHUMIDIFIER:
      ResultSvg = RoomDehumidifierSvg;

      break;
    case RoomIconKey.EMERGENCY_HVAC:
      ResultSvg = EmergencyHvacSvg;

      break;
    case RoomIconKey.EMERGENCY_HVAC_LARGE:
      ResultSvg = EmergencyHvacLargeSvg;

      break;
    case RoomIconKey.EMERGENCY_LEAK:
      ResultSvg = EmergencyLeakSvg;

      break;
    case RoomIconKey.EMERGENCY_ELECTRICITY:
      ResultSvg = EmergencyElectricitySvg;

      break;
    case RoomIconKey.EMERGENCY_ELECTRICITY_LARGE:
      ResultSvg = EmergencyElectricityLargeSvg;

      break;
    case RoomIconKey.EMERGENCY_CARBON_MONOXIDE:
      ResultSvg = EmergencyCarbonMonoxideSvg;

      break;
    case RoomIconKey.EXHAUST_FAN:
      ResultSvg = RoomElectricityFanSvg;

      break;
    case RoomIconKey.FLOOD:
      ResultSvg = RoomFloodingSvg;

      break;
    case RoomIconKey.FLOOD_LARGE:
      ResultSvg = RoomFloodingLargeSvg;

      break;
    case RoomIconKey.FROZEN_PIPE:
      ResultSvg = RoomFrozenPipeSvg;

      break;
    case RoomIconKey.FURNACE:
      ResultSvg = RoomFurnaceSvg;

      break;
    case RoomIconKey.FURNACE_LARGE:
      ResultSvg = RoomFurnaceLargeSvg;

      break;
    case RoomIconKey.GAS_LEAK:
      ResultSvg = RoomGasLeakSvg;

      break;
    case RoomIconKey.GENERATOR:
      ResultSvg = RoomGeneratorSvg;

      break;
    case RoomIconKey.GRINDER:
      ResultSvg = RoomGrinderSvg;

      break;
    case RoomIconKey.HUMIDIFIER:
      ResultSvg = RoomHumidifierSvg;

      break;
    case RoomIconKey.HVAC_UNIT:
      ResultSvg = RoomHvacOutdoorUnitSvg;

      break;
    case RoomIconKey.HVAC_UNIT_ATTIC:
      ResultSvg = RoomHvacAirHandlerSvg;

      break;
    case RoomIconKey.HW_HEATER:
      ResultSvg = RoomHotWaterHeaterSvg;

      break;
    case RoomIconKey.LIGHT_CHANDELIER:
      ResultSvg = RoomElectricityLightChandelierSvg;

      break;
    case RoomIconKey.LIGHT_EXTERIOR:
      ResultSvg = RoomElectricityLightOutdoorSvg;

      break;
    case RoomIconKey.LIGHT_PENDANT:
      ResultSvg = RoomElectricityLightPendantSvg;

      break;
    case RoomIconKey.LIGHT_SIMPLE:
      ResultSvg = RoomElectricityLightBulbSvg;

      break;
    case RoomIconKey.LIGHT_SWITCH:
      ResultSvg = RoomElectricitySwitchSvg;

      break;
    case RoomIconKey.LIGHT_SWITCH_LARGE:
      ResultSvg = RoomElectricitySwitchLargeSvg;

      break;
    case RoomIconKey.LOW_OR_NO_WATER:
      ResultSvg = RoomLowOrNoWaterSvg;

      break;
    case RoomIconKey.NOISE:
      ResultSvg = RoomNoiseSvg;

      break;
    case RoomIconKey.NO_HOT_WATER:
      ResultSvg = RoomNoHotWaterSvg;

      break;
    case RoomIconKey.OUTLET:
      ResultSvg = RoomElectricityOutletSvg;

      break;
    case RoomIconKey.OUTLET_LARGE:
      ResultSvg = RoomElectricityOutletLargeSvg;

      break;
    case RoomIconKey.PANEL:
      ResultSvg = RoomElectricityPanelSvg;

      break;
    case RoomIconKey.PLUMBING_LEAK:
      ResultSvg = RoomPlumbingLeakSvg;

      break;
    case RoomIconKey.REGISTER:
      ResultSvg = RoomVentSvg;

      break;
    case RoomIconKey.REGISTER_LARGE:
      ResultSvg = RoomVentLargeSvg;

      break;
    case RoomIconKey.SHOWER:
      ResultSvg = RoomShowerSvg;

      break;
    case RoomIconKey.SINK_BATHROOM:
      ResultSvg = RoomSinkBathroomSvg;

      break;
    case RoomIconKey.SINK_KITCHEN:
      ResultSvg = RoomSinkKitchenSvg;

      break;
    case RoomIconKey.SINK_KITCHEN_DISPOSAL:
      ResultSvg = RoomSinkKitchenDisposalSvg;

      break;
    case RoomIconKey.SINK_KITCHEN_LARGE:
      ResultSvg = RoomSinkKitchenLargeSvg;

      break;
    case RoomIconKey.SINK_UTILITY:
      ResultSvg = RoomSinkUtilitySvg;

      break;
    case RoomIconKey.SMELL:
      ResultSvg = RoomSmellSvg;

      break;
    case RoomIconKey.SOLAR:
      ResultSvg = RoomElectricitySolarSvg;

      break;
    case RoomIconKey.SPIGOT:
      ResultSvg = RoomSpigotSvg;

      break;
    case RoomIconKey.SUMP_PUMP:
      ResultSvg = RoomSumpPumpSvg;

      break;
    case RoomIconKey.THERMOSTAT:
      ResultSvg = RoomThermostatSvg;

      break;
    case RoomIconKey.THERMOSTAT_LARGE:
      ResultSvg = RoomThermostatLargeSvg;

      break;
    case RoomIconKey.TOILET:
      ResultSvg = RoomToiletSvg;

      break;
    case RoomIconKey.TRADE_ELECTRICAL:
      ResultSvg = TradeElectricalLargeSvg;

      break;
    case RoomIconKey.TRADE_HVAC:
      ResultSvg = TradeHvacLargeSvg;

      break;
    case RoomIconKey.TRADE_OTHER:
      ResultSvg = TradeOtherLargeSvg;

      break;
    case RoomIconKey.TRADE_PLUMBING:
      ResultSvg = TradePlumbingLargeSvg;

      break;
    case RoomIconKey.UV_LIGHT:
      ResultSvg = RoomUvLightSvg;

      break;
    case RoomIconKey.WATER_TREATMENT:
      ResultSvg = RoomWaterTreatmentSvg;

      break;
    case RoomIconKey.WELL_PUMP:
      ResultSvg = RoomWellPumpSvg;

      break;
    default:
      // Do nothing
      return null;
  }

  return <ResultSvg {...props} />;
};
